import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

type TypeCheckSamePasswordParams = {
  /** 사용자 아이디 */
  username: string;
  /** 새 비밀번호 */
  newPassword: string;
  /** 인증 코드 */
  verificationCode: string;
};

type TypeCheckSamePasswordResponse = {
  code: string;
  message: string;
};

/**
 * @description 로그인 세션이 없는 상태에서 새 비밀번호에 대한 검증 api 요청에 사용되는 커스텀 훅
 * @remarks 로그인 이전에, 사용자가 직접 비밀번호를 초기화하는 경우 사용합니다.
 */
const useCheckSamePasswordWithoutToken = () => {
  const { mutateAsync } = useMutation({
    mutationFn: (params: TypeCheckSamePasswordParams) => {
      const endpoint = '/labor-accounts/password/verify/by-phone-verification';
      return axiosInstance.post<TypeCheckSamePasswordResponse>(endpoint, params, { headers: { withoutToken: true } });
    },
  });

  const requestCheckSamePasswordWithoutToken = async ({
    params,
    onSuccess,
    onError,
  }: {
    params: TypeCheckSamePasswordParams;
    onSuccess?: (res: TypeCheckSamePasswordResponse) => void;
    onError?: (err: TypeErrorFormat) => void;
  }) => {
    requestHelper(() => mutateAsync(params), onSuccess, onError, undefined, { showLoading: false });
  };

  return requestCheckSamePasswordWithoutToken;
};

export default useCheckSamePasswordWithoutToken;
